import { ROUTE_PATHS } from '../config/navigation';
import managedContent from './managedContent.json';

const routePathMap = {
  dashboard: ROUTE_PATHS.dashboard,
  directory: ROUTE_PATHS.directory,
  announcements: ROUTE_PATHS.announcements,
  documents: ROUTE_PATHS.documents,
  surveys: ROUTE_PATHS.surveys,
  innovation: ROUTE_PATHS.innovation,
  events: ROUTE_PATHS.events
};

const resolvePath = (item) => item.path || routePathMap[item.pathKey] || ROUTE_PATHS.dashboard;

export const hydrateCorporateContent = (content) => ({
  managementMessages: (content.managementMessages || []).map((item) => ({
    ...item,
    ctaPath: resolvePath(item)
  })),
  cultureHighlights: content.cultureHighlights || [],
  corporateQuickAccess: (content.corporateQuickAccess || []).map((item) => ({
    ...item,
    path: resolvePath(item)
  })),
  quickContacts: content.quickContacts || [],
  systemLinks: content.systemLinks || [],
  participationLinks: (content.participationLinks || []).map((item) => ({
    ...item,
    path: resolvePath(item)
  }))
});

const corporateContent = hydrateCorporateContent(managedContent.corporate);

export const {
  managementMessages,
  cultureHighlights,
  corporateQuickAccess,
  quickContacts,
  systemLinks,
  participationLinks
} = corporateContent;

export const documentCategories = [
  {
    id: 'all',
    queryValue: 'tum-kaynaklar',
    title: 'Tum Kaynaklar',
    shortLabel: 'Tumu',
    description: 'Dokuman merkezindeki tum icerikler',
    icon: 'bx bx-grid-alt',
    keywords: []
  },
  {
    id: 'policies',
    queryValue: 'politika-prosedur',
    title: 'Politika ve Prosedurler',
    shortLabel: 'Politikalar',
    description: 'Kurumsal politika, prosedur, yonetmelik ve uyum belgeleri',
    icon: 'bx bx-shield-quarter',
    keywords: ['politika', 'prosedur', 'yonetmelik', 'iso', 'guvenlik', 'kalite', 'is sagligi']
  },
  {
    id: 'forms',
    queryValue: 'form-sablon',
    title: 'Formlar, Sablonlar ve Dilekceler',
    shortLabel: 'Formlar',
    description: 'Operasyonel ve idari sureclerde kullanilan doldurulabilir kaynaklar',
    icon: 'bx bx-detail',
    keywords: ['form', 'sablon', 'dilekce', 'talep', 'basvuru']
  },
  {
    id: 'corporate',
    queryValue: 'kurumsal-kaynaklar',
    title: 'Kurumsal Kaynaklar',
    shortLabel: 'Kurumsal',
    description: 'Calisan el kitabi, sirket sunumu, organizasyon yapisi ve tanitim icerikleri',
    icon: 'bx bx-building-house',
    keywords: ['calisan', 'el kitabi', 'organizasyon', 'sirket', 'sunum', 'tanitim']
  }
];

export const featuredDocumentCollections = [
  {
    id: 'policies',
    title: 'Kurumsal Politika ve Prosedurler',
    description: 'Guncel kurumsal standartlar, kalite belgeleri ve uyum dokumanlari icin ana erisim noktasi.',
    categoryId: 'policies',
    ctaLabel: 'Politikalara git'
  },
  {
    id: 'forms',
    title: 'Formlar ve Sablonlar',
    description: 'Sik kullanilan basvuru, talep ve operasyon sablonlarini tek akista bulun.',
    categoryId: 'forms',
    ctaLabel: 'Formlari goruntule'
  },
  {
    id: 'corporate',
    title: 'Kurumsal Tanitim Icerigi',
    description: 'Kurum kulturu, organizasyon yapisi ve ortak dil icin kullanilan temel kaynaklar.',
    categoryId: 'corporate',
    ctaLabel: 'Kurumsal kaynaklari ac'
  }
];

export const getCorporateContentFallback = () => ({
  managementMessages: [...managementMessages],
  cultureHighlights: [...cultureHighlights],
  corporateQuickAccess: [...corporateQuickAccess],
  quickContacts: [...quickContacts],
  systemLinks: [...systemLinks],
  participationLinks: [...participationLinks]
});

export default corporateContent;
